export default "__VITE_ASSET__Bo4pinrp__"